import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle } from 'reactstrap';
import classnames from 'classnames';

import './dropdown_list.scss';

class DropdownList extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { open: false };
  }

  toggle() {
    this.setState({ open: !this.state.open });
  }

  render() {
    const {
      buttonClassName,
      className,
      color,
      dropdownText,
      objectIcon,
      textClassName,
    } = this.props;

    let caret = false;
    let dropdownChild = dropdownText;
    if (dropdownText && objectIcon) {
      dropdownChild = (
        <span className={textClassName}>
          <i className={objectIcon} /> {dropdownText}
        </span>
      );
    } else if (objectIcon) {
      dropdownChild = <i className={objectIcon} />;
      caret = false;
    }

    return (
      <Dropdown
        className={classnames('dropdown-list', className)}
        isOpen={this.state.open}
        toggle={this.toggle}
      >
        <DropdownToggle className={buttonClassName} color={color} caret={caret}>
          {dropdownChild}
        </DropdownToggle>
        {this.props.children}
      </Dropdown>
    );
  }
}

DropdownList.propTypes = {
  buttonClassName: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  dropdownText: PropTypes.string,
  objectIcon: PropTypes.string,
  textClassName: PropTypes.string,
};

DropdownList.defaultProps = {
  color: 'link',
};

export default DropdownList;
